import React, { useContext, useEffect } from "react";
import { Controller, useForm } from "react-hook-form";
import { useNavigate, useSearchParams } from "react-router-dom";

import { Button } from "primereact/button";
import { InputText } from "primereact/inputtext";
import { SelectButton } from "primereact/selectbutton";

import EntityFormPage from "../../../../components/EntityFormPage/EntityFormPage";
import { ToastContext } from "../../../../App";
import { useCreateDiningOptionMutation } from "../../../../redux/services/diningOption";
import getSubdomain from "../../../../utils/getSubdomain";

import * as styles from "../DiningOptions.module.css";

const LIST_PATH = "/app/manager/dining-options";

function DiningOptionCreatePage() {
  const showToast = useContext(ToastContext);
  const navigate = useNavigate();
  const [searchParams] = useSearchParams();
  const stationId = searchParams.get("station");

  const { control, handleSubmit } = useForm({
    defaultValues: { title: "", active: "Active" },
  });

  const [
    createDiningOption,
    {
      isSuccess: isCreateDiningOptionSuccess,
      isError: isCreateDiningOptionError,
      error: createDiningOptionError,
    },
  ] = useCreateDiningOptionMutation();

  useEffect(() => {
    if (isCreateDiningOptionSuccess) {
      showToast("success", "Dining option", "Dining option created!");
      navigate(LIST_PATH);
    }
  }, [isCreateDiningOptionSuccess]);

  useEffect(() => {
    if (isCreateDiningOptionError) {
      showToast(
        "error",
        createDiningOptionError?.status,
        createDiningOptionError?.data?.message ||
          (createDiningOptionError?.data?.errors && "Incorrect data"),
      );
    }
  }, [isCreateDiningOptionError]);

  const onCreate = (data) => {
    if (!stationId) {
      showToast("warn", "Warning", "Select a station first");
      return;
    }
    createDiningOption({
      subdomain: getSubdomain(),
      data: {
        name: data.title,
        station_id: Number(stationId),
        active: data.active === "Active",
      },
    });
  };

  const handleKeyDown = (e) => {
    if (e.key === "Enter") {
      e.preventDefault();
      handleSubmit(onCreate)();
    }
  };

  return (
    <EntityFormPage
      title="New Dining Option"
      backTo={LIST_PATH}
      footer={
        <Button
          label="Save"
          type="submit"
          className={`p-button-success ${styles.saveBtn}`}
          onClick={handleSubmit(onCreate)}
        />
      }
    >
      <form onSubmit={handleSubmit(onCreate)}>
        <Controller
          name="title"
          control={control}
          render={({ field }) => (
            <div className="field">
              <label>Title</label>
              <InputText
                className={`w-full mb-3 ${styles.input}`}
                onKeyDown={handleKeyDown}
                placeholder="Title"
                {...field}
              />
            </div>
          )}
        />

        <Controller
          name="active"
          control={control}
          render={({ field }) => (
            <SelectButton
              {...field}
              options={["Active", "Inactive"]}
              allowEmpty={false}
              className={`${styles.selectButton}`}
            />
          )}
        />

        <button type="submit" hidden />
      </form>
    </EntityFormPage>
  );
}

export default DiningOptionCreatePage;
